const Colors = {
    error: 'red',
    coinsMain: "#37A8FF",
    
    mainColor: '#0091EA', 
    addPost: '#0091EA',
    tabActive: 'rgb(59,89,152)',
    tabInactive: '#ccc',
    blue:"#3498DB",

    darkText: "#2D2D2D",
    softText: "#D1D1D1",
    middleText: "#757575",
    borderColor: "#eee",
    mainColorText: "#019CF8",
    greyBackground: "#F9F9F9",

    red: "#EE4D4D",
    orange: "#FF884D",
    yellow: "#FFC44D",
    green:"#8BC94D",
    lightBlue:"#4DC4FF",
    darkBlue: "#5E94FF",
    purple: "#A071FF",
    pink: "#FF4DA5",

    facebook: "#4267B2",
    google: "#DB4437",
    twitter: "#1DA1F2",
    instagram: "#C82D8D",
    youtube: "#FF0000",
    snapchat: "#FFC315",
    link: "#0645AD",
    getColor: function(coins){
      if(coins >= 1000)
        return this.red
      else if(coins >= 700)
        return this.purple
      else if(coins >= 500)
        return this.orange
      else if(coins >= 250)
        return this.yellow
      else if(coins >= 100)
        return this.green
      else if(coins >= 50)
        return this.lightBlue
      else if(coins >= 20)
        return this.darkBlue
      else
        return "black"
    },
  };
export default Colors;